import { createAuthClient } from "better-auth/react";
import { emailOTPClient, phoneNumberClient } from "better-auth/client/plugins";

export type WebAuthClientConfig = {
  baseURL: string;
};

export function createWebAuthClient(config: WebAuthClientConfig) {
  return createAuthClient({
    baseURL: config.baseURL,
    plugins: [phoneNumberClient(), emailOTPClient()],
  });
}

export type WebAuthClient = ReturnType<typeof createWebAuthClient>;
